import { Component, OnDestroy, OnInit } from "@angular/core";
import { BaseComponent } from "../../base/base.component";
import { Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { TranslateService } from "@ngx-translate/core";
import { UserService } from "../../service/user.service";
import { RemoveAreaGQL, UpdateAreaGQL, User } from "../../../generated/graphql";
import { QueryRef } from "apollo-angular";
import { ExcelService } from "../../service/excel.service";
import { IDropSettings } from "../my-list/interfaces/drop-settings.interface";
import {
  DischargeBuyMovGQL,
  GetAllBuyMovGQL,
  UpdateBuyMovGQL,
  SearchBuyGQL,
  RemoveBuyMovGQL,
} from "graphql/buy/buy_mov.definition";
import {
  BuyMov,
  GetAllBuyMovQuery,
  SearchBuyInput,
  SearchBuyMovInput,
  SearchBuyMovQuery,
  UpdateBuyMovInput,
} from "src/app/model/buymov";

declare var $: any;

@Component({
  selector: "app-purchases-exchanges",
  templateUrl: "./purchases-exchanges.component.html",
  styleUrls: ["./purchases-exchanges.component.scss"],
})
export class PurchasesExchangesComponent
  extends BaseComponent
  implements OnInit, OnDestroy
{
  user: User = new User();
  searchBuyQuery: QueryRef<SearchBuyMovQuery>;
  allBuyQuery: QueryRef<GetAllBuyMovQuery>;
  searchBuyMovInput: SearchBuyInput = new SearchBuyInput();
  buttonExcel: boolean;
  buyInput: BuyMov = new BuyMov();
  buys: BuyMov[];
  sortOption = 'date_desc';
  buyMovId: string;

  dropSettings: IDropSettings = {
    singleSelection: false,
    idField: "id",
    textField: "name",
    selectAllText: "Marcar todos",
    unSelectAllText: "Desmarcar todos",
    itemsShowLimit: 3,
    allowSearchFilter: true,
  };

  listStatusItems = [];

  listStatusDrop = [
    { id: "Pending", name: "Pendente" },
    { id: "Completed", name: "Entregue" },
    { id: "Canceled", name: "Cancelado" },
    { id: "Cancellation request", name: "Solicitação de cancelamento" },
  ];

  itemOfViewDetails: BuyMov = {} as BuyMov;

  constructor(
    public router: Router,
    public loading: NgxSpinnerService,
    public userService: UserService,
    public translate: TranslateService,
    public excelService: ExcelService,
    public getAllBuyMovGQL: GetAllBuyMovGQL,
    public updateBuyMovGQL: UpdateBuyMovGQL,
    public dischargeBuyMovGQL: DischargeBuyMovGQL,
    public removeBuyMovGQL: RemoveBuyMovGQL
  ) {
    super(router, loading, translate);
  }

  ngOnInit(): void {
    this.getUserData();
    this.getAllBuy();
    this.setDatePickerConfig();
  }

  ngOnDestroy(): void {
    const el = $("#modalDetails");
    if (el[0]) {
      el.remove();
    }
  }

  setDatePickerConfig() {
    this.setDatePicker("picker-period", (start, end, label) => {
      this.searchBuyMovInput.start = start.utcOffset(0, true).format();
      this.searchBuyMovInput.end = end.utcOffset(0, true).format();
    });
  }

  getUserData() {
    this.userService.user.subscribe({
      next: (data) => {
        this.user = data as User;
        this.userProfile();
      },
      error: (err) => super.onError(err),
    });
  }

  getAllBuy() {
    this.allBuyQuery = this.getAllBuyMovGQL.watch({data: this.searchBuyMovInput});
    this.allBuyQuery.valueChanges.subscribe({
      next: ({ data }) => {
        this.buys = data.getAllBuyMov;
        this.applySort();
      },
      error: (error) => {
        this.onError(error);
      },
    });
  }

  // Ordenação client-side sobre a lista já carregada (sem paginação).
  applySort() {
    if (!this.buys) {
      return;
    }
    const time = (b: BuyMov) => (b?.buyDate ? new Date(b.buyDate).getTime() || 0 : 0);
    const sorted = [...this.buys];
    switch (this.sortOption) {
      case 'date_asc':
        sorted.sort((a, b) => time(a) - time(b));
        break;
      case 'status_asc':
        sorted.sort((a, b) => {
          if (!a?.status) { return b?.status ? 1 : 0; }
          if (!b?.status) { return -1; }
          return a.status.localeCompare(b.status);
        });
        break;
      default:
        sorted.sort((a, b) => time(b) - time(a));
    }
    this.buys = sorted;
  }

  setStatusOfFilter() {
    this.searchBuyMovInput.status = [];

    this.listStatusItems.forEach((e) => {
        this.searchBuyMovInput.status.push(e.id);
    });
  }

  searchBuy() {
    this.setStatusOfFilter()
    this.getAllBuy()
  }

  onSearch() {
    this.searchBuy();
  }

  setValueOfFilterStatus() {
    this.searchBuyMovInput.status = [];

    this.listStatusItems.forEach((item) => {
      this.searchBuyMovInput.status?.push(item.id);
    });
  }

  onChangeStatus(event: Event, item: BuyMov) {
    const target = event.target as HTMLInputElement;

    // Atualizando o objeto buyInput com os dados do item
    this.buyInput.id = item.id;
    this.buyInput = { ...item };
    delete this.buyInput["__typename"];
    delete this.buyInput["buyItems"];
    delete this.buyInput["employee"];

    // Manipulando o status baseado no valor do target (o valor do select)
    switch (target.value) {
      case "Pending":
        this.confirmMessage(
          this.translate.instant("baseComponent.warningAttention"),
          this.translate.instant("baseComponent.confirmPending"),
          () => {
            this.buyInput.status = "Pending";
            // this.updateBuy();
          }
        );
        break;

      case "Completed":
        this.confirmMessage(
          this.translate.instant("baseComponent.warningAttention"),
          this.translate.instant("baseComponent.confirmCompleted"),
          () => {
            this.buyInput.status = "Completed";
            // this.updateBuy();
          }
        );
        break;

      case "Canceled":
        this.confirmMessage(
          this.translate.instant("baseComponent.warningAttention"),
          this.translate.instant("baseComponent.confirmCanceled"),
          () => {
            this.buyInput.status = "Canceled";
            // this.updateBuy();
          }
        );
        break;

      // Adicione mais casos conforme necessário
      default:
        break;
    }
  }

  onRemoveBuyMov(buyMovId: string) {
    this.removeBuyMovGQL.updateBuyMov(buyMovId).subscribe({
      next: () => {
        this.buys = this.buys.filter((item) => item.id !== buyMovId);
        this.showMessage("Sucesso", "Troca cancelada com Sucesso", "success");
        setTimeout(() => {
          location.reload();
        }, 1000);
      },
      error: (error) => {
        this.onError(error)
      },
    });
  }

  showErrorMessage(message: string) {
    alert(message);
  }

  onDischarge(buyMovId: string) {
    this.buyMovId = buyMovId;

    this.dischargeBuyMovGQL
      .mutate({
        buyMovId: this.buyMovId,
      })
      .subscribe({
        next: () => {
          this.showMessage("Sucesso", "Baixa realizada com Sucesso", "success");

          setTimeout(() => {
            location.reload();
          }, 1000);
        },
        error: (error) => {
          this.showMessage('Atenção', "Erro ao tentar realizar baixa");
        },
      });
  }

  showSuccessMessage(message: string, callback: () => void) {
    alert(message);
    callback();
  }

  consoleSuccess(message: string) {
    console.log("%c" + message, "color: green; font-weight: bold;");
  }

  onViewDetails(item: BuyMov) {
    this.itemOfViewDetails = Object.assign({}, item);
    super.showModal("modalDetails");
  }

  translateStatus(status) {
    switch (status) {
      case "Pending":
        return "Pendente";
      case "Completed":
        return "Entregue";
      case "Canceled":
        return "Cancelada";
      case "Cancellation request":
        return "Solicitação de cancelamento";
    }
  }

  getStatusClass(status) {
    switch (status) {
      case "Pending":
        return "pending";
      case "Completed":
        return "completed";
      case "Canceled":
        return "canceled";
      case "Cancellation request":
        return "cancellation-request";
    }
  }

  actionExcel() {
    this.excelService.getExcelPurchases(this.searchBuyMovInput).subscribe({
      next: (data) => {
        this.downloadHandlerFile(data);
      },
      error: (err) => super.onError(err),
    });
  }

  userProfile() {
    switch (this.user.role) {
      case "committee-member":
        this.buttonExcel = false;
        break;
      default:
        this.buttonExcel = true;
        break;
    }
  }
}
